import { render, staticRenderFns } from "./FansFollow.vue?vue&type=template&id=5217fe2c&scoped=true"
import script from "./FansFollow.vue?vue&type=script&lang=js"
export * from "./FansFollow.vue?vue&type=script&lang=js"
import style0 from "./FansFollow.vue?vue&type=style&index=0&id=5217fe2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217fe2c",
  null
  
)

export default component.exports